var App = App || {};

App.SubnavMenus = (function() {
  'use strict';

  var initialize = function() {
    _bindSubnavSelects();
  };

  var _bindSubnavSelects = function() {
    $('.js-navigate-on-select').on('change', function() {
      window.location.href = $(this).val();
    });
  };

  return {
    initialize: initialize
  };
}());